export const locales = {
	en: {
		name: "English",
		flag: "EN",
		emoji: "🇺🇸",
	},
	it: {
		name: "Italiano",
		flag: "IT",
		emoji: "🇮🇹",
	},
} as const;

export type LocaleCode = keyof typeof locales;

export const supportedLocales = Object.keys(locales) as LocaleCode[];

export const defaultLocale: LocaleCode = "en";

export function normalizeLocale(locale: string | null | undefined): LocaleCode {
	if (!locale) {
		return defaultLocale;
	}

	const normalized = locale.toLowerCase();
	return supportedLocales.includes(normalized as LocaleCode)
		? (normalized as LocaleCode)
		: defaultLocale;
}
